/* tslint:disable */
/* eslint-disable */
/**
 * MG-DX Patient API
 * API for Patient
 *
 * The version of the OpenAPI document: 0.2.0
 * Contact: developers@mg-dx.co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { tzDate } from "@mgdx-libs/dayjs";
import { exists, mapValues } from "../runtime";

export const PatientMedicineNotebookShareFamilyAccountTypename = "PatientMedicineNotebookShareFamilyAccount" as const;

/**
 *
 * @export
 * @interface PatientMedicineNotebookShareFamilyAccount
 */
export interface PatientMedicineNotebookShareFamilyAccount {
  /**
   *
   * @type {string}
   * @memberof PatientMedicineNotebookShareFamilyAccount
   */
  dateOfBirth?: string;
  /**
   *
   * @type {string}
   * @memberof PatientMedicineNotebookShareFamilyAccount
   */
  firstName: string;
  /**
   *
   * @type {string}
   * @memberof PatientMedicineNotebookShareFamilyAccount
   */
  gender?: PatientMedicineNotebookShareFamilyAccountGenderEnum;
  /**
   *
   * @type {number}
   * @memberof PatientMedicineNotebookShareFamilyAccount
   */
  id: number;
  /**
   *
   * @type {string}
   * @memberof PatientMedicineNotebookShareFamilyAccount
   */
  lastName: string;
  /**
   * Resource type name
   * @type {string}
   * @memberof PatientMedicineNotebookShareFamilyAccount
   */
  readonly __typename?: string;
}

/**
 * @export
 * @enum {string}
 */
export enum PatientMedicineNotebookShareFamilyAccountGenderEnum {
  Male = "male",
  Female = "female",
  None = "none",
}

export function PatientMedicineNotebookShareFamilyAccountFromJSON(
  json: any
): PatientMedicineNotebookShareFamilyAccount {
  return PatientMedicineNotebookShareFamilyAccountFromJSONTyped(json, false);
}

export function PatientMedicineNotebookShareFamilyAccountFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): PatientMedicineNotebookShareFamilyAccount {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    __typename: PatientMedicineNotebookShareFamilyAccountTypename,

    dateOfBirth: !exists(json, "date_of_birth") ? undefined : json["date_of_birth"],
    firstName: json["first_name"],
    gender: !exists(json, "gender") ? undefined : json["gender"],
    id: json["id"],
    lastName: json["last_name"],
  };
}

export function PatientMedicineNotebookShareFamilyAccountToJSON(
  object?: PatientMedicineNotebookShareFamilyAccount | null
): any {
  if (object === undefined) {
    return undefined;
  }
  if (object === null) {
    return null;
  }
  const { __typename, ...value } = object;
  return {
    date_of_birth: value.dateOfBirth,
    first_name: value.firstName,
    gender: value.gender,
    id: value.id,
    last_name: value.lastName,
  };
}
